import { useQuery } from 'shared/apollo';

import { gql } from 'apollo-boost';

const accountQuery = gql`
  query {
    myAccount {
      id
      name
      ein
      website
      missionStatement
      officeLocation
      logoFile
      type
      woman
      personOfColor
      numberOfWomen
      numberOfpeopleOfColor
      totalNumber
      userId
      userPronoun
      userLogo
      features {
        name
        value
      }
    }
  }
`;

export default () => {
  const data = useQuery(accountQuery);
  if (!data) {
    return undefined;
  }

  const {
    myAccount: [account],
  } = data;
  return account;
};
